var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-user-list',{attrs:{"role":"venue","users":_vm.users,"columns":['name', 'email', 'role', 'accountName'],"headers":_vm.headers,"columnProps":{
    venue: { class: 'venue-cell' },
    role: { class: 'role-cell' },
  }},on:{"userClick":_vm.onUserClick,"addUser":_vm.onAddUser,"removeUser":_vm.onRemoveUser}},[_c('ez-venue-user-modal',{ref:"userModal",attrs:{"roles":_vm.roles,"formKey":_vm.formKey,"formAction":_vm.formAction,"groupId":_vm.groupId,"userId":_vm.selectedUserId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }